import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {AuthService} from '@services/auth.service';
import {catchError, tap} from 'rxjs/operators';
import {DateService} from '@services/date.service';
import {Router} from '@angular/router';
import {EventsService} from '@services/events.service';
import {ApplicationConfigService} from '@services/application-config.service';

/**
 * Перехватывает запросы от HttpClientModule, внедряет в них токен авторизации
 * и обрабатывает неаторизованные ответы
 */

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
    constructor(
        private authService: AuthService,
        private router: Router,
        private appConfig: ApplicationConfigService,
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token: string = this.authService.getToken();

        let headers = req.headers.set('Authorization', token ? token : '');
        headers = headers.set('TimezoneOffsetMinutes', '' + DateService.getTimeZoneOffset());

        const authReq = req.clone({
            headers: headers
        });

        return next.handle(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
                const { status } = error;

                /**
                 * Отлавливаем и обрабатываем тут только ошибки авторизации,
                 * при этом прокидываем дальше null в качестве ошибки, чтобы оно дошло как обычная ошибка до клиента,
                 * а не как HttpErrorResponse
                 */
                if (status === 401) {
                    this.authService.logout();
                    throw null;
                }

                if (status === 403) {
                    this.router.navigate(['/forbidden']);
                    throw null;
                }

                /**
                 * Если это не ошибка авторизации, то прокидываем её дальше
                 */
                throw error;
            }),
            tap((res: HttpResponse<any>) => {
                /**
                 * Забираем версию приложения из заголовка ответа
                 */
                const version = res && res.headers && res.headers.get && res.headers.get('App-Version');
                if (version) {
                    this.appConfig.appVersion = version;
                }
            }),
        );
    }
}
